import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {RoutesEnum} from '../../core/services/navigation/routes.enum';
import {AuthGuardService} from '../../core/services/security/auth-guard.service';
import {HealthCenterComponent} from './health-center.component';
import {HealthCentersRoutesEnum} from './services/navigation/health-centers-routes.enum';
import {HealthCentersListComponent} from './health-centers-list/health-centers-list.component';
import {CreateEditHealthCenterComponent} from './create-edit-health-center/create-edit-health-center.component';
import {HealthCenterResolver} from './services/resolver/health-center.resolver';
import {HealthCenterDetailsComponent} from './health-center-details/health-center-details.component';

const routes: Routes = [
  {
    path: RoutesEnum.HEALTH_CENTERS,
    component: HealthCenterComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: HealthCentersRoutesEnum.LIST,
        component: HealthCentersListComponent,
      },
      {
        path: HealthCentersRoutesEnum.CREATE,
        component: CreateEditHealthCenterComponent,
      },
      {
        path: HealthCentersRoutesEnum.EDIT,
        component: CreateEditHealthCenterComponent,
        resolve: {healthCenter: HealthCenterResolver},
      },
      {
        path: HealthCentersRoutesEnum.VIEW,
        component: HealthCenterDetailsComponent,
        resolve: {healthCenter: HealthCenterResolver},
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class HealthCenterRoutingModule {
}
